// Overlay use className props to pass style properties to child component.
// To make this component work add className props to your child component manually.
// Here an example: https://gist.github.com/Miniplop/8f87608f8100e758fa5a4eb46f9d151f

import React from "react";
import { IconOutlinedUser } from "./../components";
import styles from "./Avatar.module.scss";

const DoClk = (e) => {
  //console.log("Avatar clicked!");
}

const Avatar = () => {
  return (
    <div className={styles.avatar} onClick={DoClk}>
      <IconOutlinedUser />
    </div>
  );
};

export default Avatar;